const initialUserListFilters = {
  ordered_field: '',
  orderd_desc: 'asc',
  page: 1,
  pages: 1,
};

export default initialUserListFilters;
